export const minPasswordLength = 8;

/**
 * Returns whether a password meets the Cognito password requirements
 */
export function meetsPasswordRequirements(password: string): boolean {
	if (password.length < minPasswordLength) return false;
	if (!/\d/.test(password)) return false;
	if (!/[a-z]/.test(password)) return false;
	if (!/[A-Z]/.test(password)) return false;
	if (!/[^A-Za-z0-9]/.test(password)) return false;
	return true;
}
